<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Merchandising from "@/services/Merchandising";
import Http from "@/services/Http";
import Swal from "sweetalert2";
import ModalEditAppProduct from "../../../components/modals/merchandise/modalEditAppProduct.vue";
import ModalAddAppProduct from "../../../components/modals/merchandise/modalAddAppProduct.vue";
import ModalAddProductHighlightedImage from "../../../components/modals/merchandise/modalAddProductHighlightedImage.vue";

/**
 * Starter page
 */
export default {
  components: { Layout, PageHeader, ModalEditAppProduct,ModalAddAppProduct, ModalAddProductHighlightedImage },
  page: {
    title: "App Products",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },

  data() {
    return {
      title: "App Products",
      items: [
        {
          text: "App Products",
          href: "/",
        },
      ],
      filterData: false,
      isBusy: false,
      tableData: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 25,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "created_at",
      hasHighlighted:false,
      modalData:[],
      sortDesc: true,
      fields: [
        {
          key: "title",
          label: "Title",
        },
        {
          key: "price",
          label: "Price",
        },
        {
          key: "discount_price",
          label: "Discount Price",
        },
        {
          key: "image_url",
          label: "Image",
        },
        {
          key: "is_published",
          label: "Published"
        },
        {
          key: "is_highlighted",
          label: "Highlighted"
        },
        {
          key: "landingpage_url",
          label: "Product Link"
        },
       
        "action",
      ],
  
    };
  },
  middleware: "authentication",
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.tableData.length;
    },
    highlightedProductId() {
      const highlighted = this.tableData.find(p => p.is_highlighted == 1)
      return highlighted ? highlighted.id : null
    }
   
  },
  mounted() {
    // Set the initial number of items
    this.getAppProducts();
    this.totalRows = this.items.length;
    
  },



  methods: {

    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    openModalEditAppProducts(data){
       this.modalData = data;
       this.$bvModal.show('edit_app_products') 
    },

    openModalAddAppProducts(){
       this.$bvModal.show('add_app_products') 
    },

    openModalAddHighlight(data,status){
      console.log(data,'data');
      this.modalData = {
        ...data,
        is_highlighted: status ? 1 : 0
      }

      // if(data.image_highlighted_url == '' || data.image_highlighted_url == null){
      if(!data.image_highlighted_url){
        console.log('here one');
        this.$bvModal.show('add_app_product_highlight');
      }else{
        this.changeHighlightedStatus(
          data.is_highlighted == 1 ? 0 : 1,
          data.id
        )    
        }

    },

    openModalAddHighlightImage(data) {
      this.modalData = data;
      this.$bvModal.show('add_app_product_highlight');

    },

    async changePublishedStatus(status,productId){
        try{
            let formData = new FormData();
            formData.append("is_published",status)
            formData.append("_method","PATCH");

            const response = await Merchandising.editAppProduct(formData,productId);
            if(response.success == false){
              Swal.fire("Error",response.error || "Failed to update product published status. Please try again","error");
            }else{
              Swal.fire("Success","Product edited successfully!","success");
            }

        }catch(error){
          this.error = error.response.data.error ? error.response.data.error : "";
          this.failedmsg(this.error)
          console.error(this.error);
          this.getAppProducts()
        }
    },

    async changeHighlightedStatus(status, productId) {
      try {
        let formData = new FormData();
        formData.append("is_highlighted", status)
        formData.append("_method", "PATCH");

        const response = await Merchandising.editAppProduct(formData, productId);
        if (response.success == false) {
          Swal.fire("Error", response.error || "Failed to update product published status. Please try again", "error");
        } else {
          Swal.fire("Success", "Product edited successfully!", "success");
          this.getAppProducts();
        }

      } catch (error) {
        this.error = error.response.data.error ? error.response.data.error : "";
        this.failedmsg(this.error)
        console.error(this.error);
        this.getAppProducts()
      }
    },


    async getAppProducts() {
      try {
        this.filterData = true;
        this.toggleBusy();
        let filters = this.getFilters()
        const response = await Merchandising.getAppProducts(filters)
        this.tableData = response.data.products;
        this.toggleBusy();
      }
      catch (error) {
        this.error = error.response.data.error ? error.response.data.error : "";
        this.tableData = [];
      }
    },


    getFilters() {
      var filter_string = '&limit=1000';
      filter_string += '&is_published=all';
      // filter_string += (this.filterInput.product_name) ? '&name=' + this.filterInput.product_name : "";
      // filter_string += (this.selectedCategoryId) ? '&category_id=' + this.selectedCategoryId : "";
      // //            filter_string += (this.filterInput.tag) ? '&tag=' + this.filterInput.tag : "";
      // filter_string += (this.filterInput.withpic) ? '&withpic=' + this.filterInput.withpic : "";
      return filter_string = filter_string.substring(1);
    },

    async deleteAppProduct(productId) {

      Swal.fire({
        title: "Delete App Product?",
        text: "This App Product will be deleted!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Delete"
      }).then(async (result) => {
        if (result.isConfirmed === true) {
          try {
            const response = await Merchandising.deleteAppProduct(productId);
            if (response.data.success) {
              Swal.fire("Success!", "App Porduct is successfully deleted!", "success");
              await this.getAppProducts();
            } else {
              const error = response.error ? response.error : 'Failed';
              Swal.fire("Fail!", error, "warning");
            }
          } catch (error) {
            this.error = error.response && error.response.data && error.response.data.error
              ? error.response.data.error
              : "An error occurred while removing the product.";
            Swal.fire("Error", this.error, "error");
          }

        }
      })
    },

    failedmsg(msg) {
      Swal.fire({
        position: "center",
        icon: "error",
        title: msg,
        showConfirmButton: false,
        timer: 50000,
      });
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" v-show="filterData">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
              <a href="javascript:void(0);" class="btn btn-success waves-effect waves-light" @click="openModalAddAppProducts()">
              Add Product
            </a>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6" v-show="filterData">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input v-model="filter" type="search" placeholder="Search..."
                      class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <b-table
                 :busy="isBusy"
                 table-class="table table-centered datatable table-card-list"
                 thead-tr-class="bg-transparent"
                :items="tableData"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                show-empty
                empty-text="No Data Found"
                @filtered="onFiltered">


              <template #table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              </template>

              <template v-slot:cell(landingpage_url)="data">
                  <a :href="data.item.landingpage_url" target="_blank">{{ data.item.landingpage_url }}</a>
              </template>

              <template v-slot:cell(image_url)="data">
                  <img v-if="data.item.image_url" :src="data.item.image_url" :alt="data.item.title" style="width: 100px;" />
                  <img v-else src="../../../assets/images/image_not_found.png" style="width:100px;"/>
              </template>

<!-- 
               <template v-slot:cell(image_highlighted_url)="data">
                  <img v-if="data.item.image_highlighted_url" :src="data.item.image_highlighted_url" :alt="data.item.title" style="width: 100px;" />
                  <img v-else src="../../../assets/images/image_not_found.png" style="width:100px;"/>
              </template> -->

              <template v-slot:cell(is_published)="data">
                   <div class="form-check form-switch form-switch-lg mb-3">
                  <input @change="changePublishedStatus(data.item.is_published,data.item.id)" v-model="data.item.is_published" type="checkbox" class="cursor-pointer form-check-input" id="switch1" true-value="1"
                    false-value="0" />
                </div>
              </template>
            
              
              <template v-slot:cell(is_highlighted)="data">
                <div class="d-flex ">
                   <div  :title="highlightedProductId && data.item.id !== highlightedProductId
                      ? 'Only one product can be highlighted'
                      : ''
                    " class="cursor-pointer form-check form-switch form-switch-lg mb-3">
                    <input 
                         type="checkbox"
                         class="cursor-pointer form-check-input"
                        :checked="data.item.is_highlighted == 1"
                         @click.prevent="openModalAddHighlight(data.item, data.item.is_highlighted == 0)"
                        :disabled="highlightedProductId && data.item.id !== highlightedProductId"
                        id="switch1" true-value="1" false-value="0"
                        />
                  </div>
                  <div v-if="data.item.is_highlighted == 1 && data.item.image_highlighted_url !== ''">
                    <i  @click="openModalAddHighlightImage(data.item)" title="Edit Highlihted Image" class="cursor-pointer uil uil-image font-size-18 text-primary"></i>
                  </div>
                </div>
              </template>


              <template v-slot:cell(action)="data">
                <ul class="list-inline mb-0 d-flex">
                  <li class="list-inline-item" title="Edit App Product">
                    <i class="cursor-pointer uil uil-pen font-size-18 text-primary" @click="openModalEditAppProducts(data.item)"></i>
                  </li>
                  <li class="list d-inline mb-0" title="Delete App Product">
                      <i class="cursor-pointer uil uil-trash-alt font-size-18 text-danger" @click="deleteAppProduct(data.item.id)"></i>
                  </li>
                </ul>
              </template>

            </b-table>

            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ModalAddAppProduct @onRefresh="getAppProducts()"></ModalAddAppProduct>
    <ModalEditAppProduct :appProduct="modalData" @onRefresh="getAppProducts()"></ModalEditAppProduct>
    <ModalAddProductHighlightedImage :appProduct="modalData" @onRefresh="getAppProducts()"></ModalAddProductHighlightedImage>
  </Layout>
</template>
